import type {
  QuizConditionValuesResponse,
  QuizForInstance,
  StartQuizRequest,
  StartQuizResponse,
  SubmitQuizRequest,
  SubmitQuizResponse,
} from "@repo/shared/types";
import { getWithToken, postWithToken } from "../_client";

const BASE = "/public/flow/quiz";

/** QL-698 — `__quiz_score_<id>` values resolved server-side from the full value. */
export function getPublicQuizConditionValues(token: string) {
  return getWithToken<QuizConditionValuesResponse>(`${BASE}/condition-values`, token);
}

export function getPublicQuizzes(token: string) {
  return getWithToken<QuizForInstance[]>(`${BASE}/quizzes`, token);
}

/** QL-505 — `subjectId` addresses one party when several answer (a group member, or a representative when 2+ are registered). */
export function startPublicQuiz(token: string, quizId: string, subjectId?: string) {
  return postWithToken<StartQuizResponse>(`${BASE}/start`, token, {
    quizId,
    ...(subjectId ? { subjectId } : {}),
  } satisfies StartQuizRequest);
}

export function submitPublicQuiz(token: string, request: SubmitQuizRequest) {
  return postWithToken<SubmitQuizResponse>(
    `${BASE}/submit`,
    token,
    request satisfies SubmitQuizRequest,
  );
}

// No override wrapper: clearing a failed quiz by hand is an advisor action, and
// the public route does not exist.
